import React, { Suspense, useEffect, useState } from "react";
import { Check } from '@mui/icons-material';
import styled from "styled-components";

const Lottie = React.lazy(() => import('lottie-react'));
import Loading from "components/Loading";
import { Skeleton } from "antd";
import * as Sentry from '@sentry/react';

const LoaderWrapper = styled.div`
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 40%;
`;

const AvatarContainer = styled.div`

`;
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.5); /* semi-transparent white */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const AvatarCard = ({
  avatar,
  isSelected,
  onSelect,
  shadow = 'none',
  index,
  loader = false
}) => {
  const [animationData, setAnimationData] = useState(null);
  const [loadingAnimation, setLoadingAnimation] = useState(true);

  useEffect(() => {
    
      setAnimationData(avatar.poster);
      setLoadingAnimation(false);
  }, [avatar.poster]);

  return (
      <AvatarContainer
          className={`addShadowLottie-${index} ${isSelected ? 'addShadowLottieSelected' : ''}`}
          style={{
              height: 135,
              width: 135,
              cursor: 'pointer',
              position: 'relative',
              filter: shadow
          }}
          onClick={() => onSelect(avatar.key)}
      >
      {isSelected && (
         <Check color="primary" style={{ position: "absolute", right: 0, top: 5, background: "#fff", borderRadius: "50%", zIndex: 999 }} />
      )}
      {loader ? <LoaderWrapper> <Loading size={25} /> </LoaderWrapper> : null}
      {loadingAnimation && (
        <Overlay>
           <Skeleton.Avatar active size={80} shape="circle" />
        </Overlay>
      )}
      {/* Show thumbnail while loading */}
      {loadingAnimation && (
        <img
          src={avatar.thumbnail}
          alt={avatar.key}
          style={{ height: '100%', width: '100%', objectFit: 'contain' }}
        />
      )}

      {/* Show Lottie once loaded */}
      {!loadingAnimation && animationData && (
        <Suspense fallback={null}>
          <video src={animationData} type="video/webm" style={{ height: '100%', width: '100%', objectFit: 'contain', backgroundColor: 'transparent' }} />
        </Suspense>
      )}
    </AvatarContainer>
  );
};